import Heading from "./heading/index";
import Description from "./description/index";
import ImageComponent from "./image/index";
import { BLOCKTYPES } from "../../constants";
import BookGif from "../../assets/images/book-gif.gif";
import ImageCarousel from "./carousel/index";
import AudioPlayer from "./audio/index";
import Logo from "./logo";
import EmbedVideo from "./embedvideo";
import VideoPlayer from "./video";
import Text from "./text";
import Link from "./link";
import SocialIcons from "./socialIcons";
import Bio from "./bio";
import ClipboardButton from "./clipboardButton";
import AppDownload from "./appDownload";
import LinkToPage from "./linkToQubioPage";
import ContactForm from "./contactForm";
import ContactCard from "./contactCard";
import EmailSubscribe from "./emailSubscribe";

import defaultStyle from "../../utils/default";

const getDeviceType = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    return "android";
  } else if (/iPad|iPhone|iPod/i.test(userAgent)) {
    return "ios";
  }

  return "unknown";
};

const deviceType = getDeviceType();

// This file contains the logic to render the content blocks based on the block type
export const renderContentBlocks = (data, page, pageId, userId) => {
  return page.map((item, index) => {
    switch (item?.blockType) {
      // return heading //done
      case BLOCKTYPES.HEADING:
        return (
          <Heading
            contentBlockId={item?._id}
            key={index}
            title={item.data?.heading}
            color={data?.pageStyles || defaultStyle}
          />
        );
      // return image //done
      case BLOCKTYPES.IMAGE:
        return (
          <div key={index} style={{ marginTop: "8px" }}>
            <ImageComponent
              src={item.data?.imageUrl}
              alt="book"
              gif={BookGif}
              style={item.style}
              color={data?.pageStyles || defaultStyle}
            />
            <Description
              description={item?.data?.caption}
              className="imageDescription"
              color={data?.pageStyles || defaultStyle}
            />
          </div>
        );
      // return carousel block
      case BLOCKTYPES.CAROUSEL:
        return (
          <ImageCarousel
            contentBlockId={item?._id}
            data={item.data?.carousel}
            style={item.style}
            color={data?.pageStyles || defaultStyle}
            key={index}
          />
        );
      // return Audio //done
      case BLOCKTYPES.AUDIO:
        return (
          <AudioPlayer
            contentBlockId={item?._id}
            key={index}
            audio={item.data?.audioUrl}
            title={item.data?.title}
            color={data?.pageStyles || defaultStyle}
          />
        );
      // return Logo
      case BLOCKTYPES.LOGO:
        return (
          <Logo
            contentBlockId={item?._id}
            key={index}
            src={item.data?.logoUrl}
            style={item.style}
            color={data?.pageStyles || defaultStyle}
          />
        );
      // return video //done
      case BLOCKTYPES.VIDEO:
        if (item.data?.type === "embed") {
          return (
            <EmbedVideo
              contentBlockId={item?._id}
              key={index}
              video={item.data?.videoUrl}
              thumbnail={item.data?.thumbnail}
              color={data?.pageStyles || defaultStyle}
              tag={item?.data?.tag}
            />
          );
        } else {
          return (
            <VideoPlayer
              contentBlockId={item?._id}
              key={index}
              video={item.data?.videoUrl}
              thumbnail={item.data?.thumbnail}
              isAutoPlayEnabled={item?.data?.autoPlay ?? false}
              color={data?.pageStyles || defaultStyle}
            />
          );
        }
      // return text //done
      case BLOCKTYPES.TEXT:
        return (
          <Text
            contentBlockId={item?._id}
            key={index}
            text={item.data?.text}
            color={data?.pageStyles || defaultStyle}
          />
        );
      // return link // done
      case BLOCKTYPES.LINK:
        return (
          <Link
            contentBlockId={item?._id}
            key={index}
            icon={item.data?.icon}
            buttonText={item.data?.buttonText}
            url={item.data?.url}
            color={data?.pageStyles || defaultStyle}
            highlight={item.data?.highlight}
          />
        );
      // return social icons
      case BLOCKTYPES.SOCIAL:
        return (
          <SocialIcons
            contentBlockId={item?._id}
            key={index}
            icons={item.data}
            color={data?.pageStyles || defaultStyle}
          />
        );
      // return social bio //done
      case BLOCKTYPES.BIO:
        return (
          <Bio
            key={index}
            contentBlockId={item?._id}
            bioText={item.data?.bioText}
            headline={item.data?.headline}
            url={item.data?.url}
            color={data?.pageStyles || defaultStyle}
          />
        );
      // return clipboardButton
      case BLOCKTYPES.CLIPBOAREDBUTTON:
        return (
          <ClipboardButton
            contentBlockId={item?._id}
            key={index}
            content={item.data?.content}
            icon={item.data?.icon}
            highlight={item.data?.highlight}
            color={data?.pageStyles || defaultStyle}
          />
        );
      // return appDownload
      case BLOCKTYPES.APPLINK:
        return (
          <>
            <AppDownload
              contentBlockId={item?._id}
              key={0}
              ios={item.data?.ios}
              android={item.data?.android}
              color={data?.pageStyles || defaultStyle}
              highlight={item.data?.highlight}
              index={0}
            />
            {deviceType !== "ios" && deviceType !== "android" && (
              <AppDownload
                contentBlockId={item?._id}
                key={1}
                ios={item.data?.ios}
                android={item.data?.android}
                color={data?.pageStyles || defaultStyle}
                highlight={item.data?.highlight}
                index={1}
              />
            )}
          </>
        );
      // return Link to Page
      case BLOCKTYPES.LINKEDPAGE:
        return (
          <LinkToPage
            contentBlockId={item?._id}
            key={index}
            selectedPageId={item.data?.selectedPageId}
            icon={item.data?.icon}
            buttonText={item.data?.buttonText}
            highlight={item.data?.highlight}
            color={data?.pageStyles || defaultStyle}
          />
        );
      // return Contact form
      case BLOCKTYPES.CONTACTFORM:
        return (
          <ContactForm
            contentBlockId={item?._id}
            key={index}
            email={item.data?.email}
            icon={item.data?.icon}
            buttonText={item.data?.buttonText}
            highlight={item.data?.highlight}
            formButtonText={item.data?.formButtonText}
            formConfirmationText={item.data?.formConfirmationText}
            color={data?.pageStyles || defaultStyle}
            message={item.data?.message}
            name={item.data?.name}
            phone={item.data?.phone}
            emailAddress={item.data?.emailaddress}
          />
        );
      // return Contact card
      case BLOCKTYPES.CONTACTCARD:
        return (
          <ContactCard
            contentBlockId={item?._id}
            key={index}
            data={item?.data}
            highlight={item.data?.highlight}
            color={data?.pageStyles || defaultStyle}
          />
        );

      // return email subscribe
      case BLOCKTYPES.EMAILSUBSCRIBE:
        return (
          <EmailSubscribe
            contentBlockId={item?._id}
            key={index}
            data={item?.data}
            highlight={item.data?.customize?.highlight}
            color={data?.pageStyles || defaultStyle}
          />
        );

      default:
        null;
    }
  });
};
